import { CLEAR_EMPLOYEE_APPLICATION_DETAILS } from "../../enums/Employees/employees.types";

export const clearApplicationDetailsAction = () => {
    return {
        type: CLEAR_EMPLOYEE_APPLICATION_DETAILS,
    };
};